import type { FunctionComponent } from 'react';

import { useDesktop } from '../../hooks/breakpoint';
import type { ButtonSize } from '../button/button';
import { Button } from '../button/button';

export interface IButtonCtaProps {
    className?: string;
    size: ButtonSize;
    hollow?: boolean;
    light?: boolean;
    callToAction: {
        content?: {
            longText?: string | null;
            shortText?: string | null;
            desktopURL?: string | null;
            mobileURL?: string | null;
        };
    };
}

export const ButtonCta: FunctionComponent<IButtonCtaProps> = ({
    className,
    size,
    hollow,
    light,
    callToAction,
}) => {
    const isFullDisplay = useDesktop();

    const displayText = isFullDisplay
        ? callToAction.content?.longText
        : callToAction.content?.shortText;

    const primaryHref = isFullDisplay
        ? callToAction.content?.desktopURL
        : callToAction.content?.mobileURL;

    return (
        <Button
            className={className}
            size={size}
            hollow={hollow}
            light={light}
            rawHref={true}
            href={primaryHref ?? callToAction.content?.desktopURL ?? ''}
        >
            {displayText}
        </Button>
    );
};
